const logisticStatus = {
    'TITLE': '',
}

export default logisticStatus;